export default __webpack_public_path__ + "static/Answer, summarise, prioritise-af0d10c87c1b9bd126707970fae8b402.png";